import { RubberCatalogResponse } from '@/shared/state/api/swagger';

export const selectRubberOptions = (rubberCatalog: RubberCatalogResponse[] = []) =>
	rubberCatalog?.map((rubber) => ({
		value: rubber.id,
		label: `${rubber.symbol || 'Нет обозначения'}`,
	})) || [{ value: 0, label: '' }];

export const selectRubberNamingOptions = (rubberCatalog: RubberCatalogResponse[] = []) =>
	rubberCatalog?.map((rubber) => ({
		value: rubber.id,
		label: rubber.name,
	})) || [{ value: 0, label: '' }];
